module.exports = __webpack_public_path__ + "static/media/YF07_2.57bc3e4a.jpg";